import { createContext } from 'react';
export const defaultState = {
  admins: [],
  closeTwoFactorRecovery: () => {},
  goToAdmin: () => {},
  goToSupport: () => {},
  isRecovering: false,
  isRecoveryEmailInErrorState: false,
  isTokenExpired: false,
  loadingError: false,
  onClickAdminRecovery: () => {},
  onClickSupportRecovery: () => {},
  openTwoFactorRecovery: () => {},
  ready: false,
  recoveryAttempted: false,
  recoveryNeedsSupport: false,
  recoverySent: false,
  setupTwoFactorRecoveryPage: () => {},
  twoFactorRecoveryOpen: false
};
export const TwoFactorRecoveryContext = /*#__PURE__*/createContext(defaultState);